"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { Card, CardContent } from "@/components/ui/card";
import { PortfolioRoomPicker } from "@/components/molecules/portfolio-room-picker/PortfolioRoomPicker";
import NotificationMessage from "@/components/atoms/notifications/NotificationMessage";
import { usePropertyAssociationSelect } from "./usePropertyAssociationSelect";
export function PropertyAssociationSelect() {
  const $ = _c(28);
  const {
    t,
    resource,
    eligible,
    value,
    occupiedBy,
    handleChange,
    handleRemove
  } = usePropertyAssociationSelect();
  const tStepper = useTranslations("modules.portfolio.associateListingToUnit.stepper");
  if (!eligible) {
    return null;
  }
  let t0;
  if ($[0] !== t) {
    t0 = t("associateProperty");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <p className="font-semibold text-foreground">{t0}</p>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("associatePropertyHint");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <p className="text-xs text-muted-foreground">{t2}</p>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <div className="flex flex-col gap-1 min-w-0 flex-1">{t1}{t3}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t("associatePropertyCta");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== handleChange || $[14] !== handleRemove || $[15] !== resource || $[16] !== t5 || $[17] !== value) {
    t6 = <PortfolioRoomPicker resource={resource} value={value} onChange={handleChange} onClear={handleRemove} placeholder={t5} variant="primary" className="w-full md:w-auto md:min-w-[220px] md:max-w-[320px]" data-sentry-element="PortfolioRoomPicker" data-sentry-source-file="PropertyAssociationSelect.tsx" />;
    $[13] = handleChange;
    $[14] = handleRemove;
    $[15] = resource;
    $[16] = t5;
    $[17] = value;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t4 || $[20] !== t6) {
    t7 = <div className="flex flex-col md:flex-row md:items-center gap-4">{t4}{t6}</div>;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== occupiedBy || $[23] !== tStepper) {
    t8 = occupiedBy && <NotificationMessage variant="warning" hasCloseButton={false} isHtml={true} description={tStepper.markup("replaceWarning", {
      title: occupiedBy,
      b: _temp
    })} />;
    $[22] = occupiedBy;
    $[23] = tStepper;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t7 || $[26] !== t8) {
    t9 = <Card className="bg-card border border-border shadow-none" data-sentry-element="Card" data-sentry-component="PropertyAssociationSelect" data-sentry-source-file="PropertyAssociationSelect.tsx"><CardContent className="flex flex-col gap-4 p-4" data-sentry-element="CardContent" data-sentry-source-file="PropertyAssociationSelect.tsx">{t7}{t8}</CardContent></Card>;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
}
function _temp(chunks) {
  return `<b class="font-semibold">${chunks}</b>`;
}